import React, { useState } from "react";
import styles from "./style.module.css";
function DynamoLayout() {
  const [rowsNumberInput, setRowsNumberInput] = useState("");
  const [data, setData] = useState({});
  const addRow = () => {
    setData({
      id: 1,
      name: "Home Layout",
      rows: rowsNumberInput,
      fields: Array.from({ length: rowsNumberInput }, (_, i) => ({
        id: i + 1,
        cols: [],
      })),
    });
  };
  const addCol = (value, i) => {
    if (!value) {
      // console.log("Empty");
      return;
    }
    let newData = { ...data };
    let columns = newData.fields[i].cols;
    let totalCol = columns.reduce((total, num) => total + num.size, 0);
    if (totalCol + value <= 12) {
      data.fields[i].cols.push({
        id: columns.length ? columns[columns.length - 1]?.id + 1 : 1,
        size: value,
      });
      // console.log(newData);
      setData(newData);
    } else {
      // console.log(totalCol + value);
      // console.log(data);
      alert("Sum is above 12");
    }
  };
  const delCol = (rowI, colID) => {
    // console.log("deleted");
    let newData = { ...data };
    let columns = newData.fields[rowI].cols;
    newData.fields[rowI].cols = columns.filter((col)=> col.id !== colID);
    setData(newData);
  };

  return (
    <div className={`contaniner-fluid py-5 ${styles.bgLightGrey}`}>
      <div className="container bg-light p-2 pb-5 rounded">
        <div className="mb-4 d-flex col-lg-6 col-md-12 col-sm-12 col-12 p-2">
          <input
            min="0"
            max="9999"
            type="number"
            value={rowsNumberInput}
            onChange={(e) => {
              setRowsNumberInput(e.target.value);
            }}
            onKeyDown={(e) => {
              if (e.key === "Enter") addRow();
            }}
            className="form-control me-3"
            id="addRows"
            placeholder="Enter Your Number of Rows"
          />
          <button type="submit" onClick={addRow} className="btn btn-primary">
            Add
          </button>
        </div>

        <div className={`p-2 rounded-4 bg-light ${styles.bgGrey}`}>
          {data?.fields?.map((row, i) => (
            <div key={`col${row.id}`} className="pt-2">
              <input
                min="0"
                max="12"
                type="number"
                className="form-control"
                id="addRows"
                placeholder="Make Columns / 12"
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    addCol(Number(e.target.value), i);
                    e.target.value = "";
                  }
                }}
              />
              <div className="d-flex pt-2 ">
                {row?.cols?.map((col) => (
                  <div key={`col${col.id}`} className={`col-${col.size} px-1`}>
                    <div
                      className={`d-flex border ${styles.minHeight} mh-100 bg-white shadow-sm rounded p-2 justify-content-between`}
                    >
                      <span>{col.size}</span>
                      <span
                        className={`px-2 rounded-circle cursor_pointer bg-black text-white ${styles.customWidthHeight}`}
                        onClick={() => delCol(i, col.id)}
                      >
                        x
                      </span>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
export default DynamoLayout;
